import http from "../../http-common";

class NewsArticlesRightSideTaxonomyService {
    getNewsArticlesRightSideTaxonomyService(productPath: string) {
        return http.get(`/right-side-section/news-articles/taxonomy?nodeName=${productPath}`);
    }
}

export default new NewsArticlesRightSideTaxonomyService();
